import { useMemo, useState } from 'react';
import CategoryTabs from './CategoryTabs';
import EventCard from './EventCard';
import { categories } from '@/mocks/gossipEvents';
import type { GossipEvent } from '@/types/gossip';

interface EventStreamProps {
  events: GossipEvent[];
}

export default function EventStream({ events }: EventStreamProps) {
  const [active, setActive] = useState('全部');
  const [showCount, setShowCount] = useState(6);

  const filtered = useMemo(() => {
    if (active === '全部') return events;
    return events.filter((event) => event.category === active);
  }, [active, events]);

  const visible = filtered.slice(0, showCount);
  const hasMore = filtered.length > showCount;

  return (
    <section id="stream" className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100 scroll-mt-20">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 flex items-center gap-2">
            事件流
            <span className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-label text-secondary-900 align-middle">
              <span className="w-1.5 h-1.5 rounded-full bg-current animate-pulse-soft"></span>
              实时跟进
            </span>
          </h2>
          <p className="mt-2 text-sm text-foreground-600">正在发酵的每一个瓜，都会在这里持续更新到有结果。</p>
        </div>
        <p className="text-xs text-foreground-500 flex items-center gap-1.5">
          <i className="ri-filter-3-line"></i>
          共 {filtered.length} 个事件
        </p>
      </div>

      <div className="mt-6">
        <CategoryTabs categories={categories} active={active} onChange={(category) => { setActive(category); setShowCount(6); }} />
      </div>

      {visible.length > 0 ? (
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {visible.map((event) => (
            <EventCard key={event.id} event={event} />
          ))}
        </div>
      ) : (
        <div className="mt-6 rounded-lg border border-dashed border-background-300 py-16 flex flex-col items-center text-center">
          <span className="w-12 h-12 rounded-full bg-background-200 flex items-center justify-center">
            <i className="ri-inbox-line text-xl text-foreground-500"></i>
          </span>
          <p className="mt-3 text-sm text-foreground-600">这个分类暂时还没有瓜，换个分类看看吧</p>
        </div>
      )}

      {hasMore && (
        <div className="mt-8 flex justify-center">
          <button
            type="button"
            onClick={() => setShowCount((prev) => prev + 3)}
            className="inline-flex items-center gap-1.5 rounded-md border border-background-300/70 bg-background-50 px-6 py-2.5 text-sm font-medium text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            加载更多瓜
            <i className="ri-arrow-down-line"></i>
          </button>
        </div>
      )}
    </section>
  );
}